export const getFormFieldName = (categoryId: string, paramDefinitionId?: string) =>
  `${categoryId}_${paramDefinitionId}`;
